<script>
  import { onMount } from 'svelte'
  import { fade } from 'svelte/transition'
  import { calledFromLabel } from '../../stores.js'
  import { createEventDispatcher } from 'svelte'
  import { sortedSpecimens } from '../sections/specimens.svelte'

  const dispatch = createEventDispatcher()
  const close = () => dispatch('close')

  const handle_keydown = (e) => {
    if (e.key === 'Escape') {
      close()
      return
    }
  }

  let g
  let image
  let name
  let width
  let containerWidth
  let totalWidth
  function buildGalleryObj() {
    if (gallery) {
      g = [...gallery.children]

      totalWidth = 0
      for (let item of g) {
        image = item.querySelectorAll('img')[0]
        name = image.getAttribute('name')
        width = image.getBoundingClientRect().width
        galleryObj.items.push({
          name: name,
          pos: totalWidth,
        })
        totalWidth += width + 20
      }
      containerWidth = gallery.getBoundingClientRect().width
      galleryObj.totalWidth = totalWidth - containerWidth - 20
    }
  }

  let gallery
  let innerHeight
  let galleryObj = {
    totalWidth: 0,
    items: [],
  }
  let calledItem
  onMount(() => {
    setTimeout(() => {
      buildGalleryObj()
      calledItem = galleryObj.items.find((x) => x.name === $calledFromLabel)
      gallery.style.setProperty('--scrollPos', -calledItem.pos + 'px')
      gallery.style.transform = 'translateX(var(--scrollPos))'

      Draggable.create(gallery, {
        type: 'x',
        overshootTolerance: 0,
        bounds: {
          minX: 0,
          maxX: -galleryObj.totalWidth,
        },
      })
    }, 400)
    return () => {
      Draggable.get(gallery).kill()
    }
  })
</script>

<svelte:window on:keydown={handle_keydown} bind:innerHeight />
<div class="content-wrapper" out:fade>
  <ul class="specimen-container" bind:this={gallery}>
    {#each sortedSpecimens as specimen}
      <li>
        <img src={specimen.path} alt={specimen.name} name={specimen.name} />
      </li>
    {/each}
  </ul>
</div>

<style lang="scss">
  .content-wrapper {
    height: 100%;
  }
  .specimen-container {
    height: 100%;
    white-space: nowrap;
    padding-bottom: 1em;
    li {
      display: inline-block;
      height: 100%;
      margin-right: 20px;
      img {
        height: 100%;
        max-width: initial;
      }
    }
  }
</style>
